import React from "react";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export default function CertificateSection({ form, setForm }) {
  const handleChange = (index, field, value) => {
    const updated = [...form.certificates];
    updated[index][field] = value;
    setForm({ ...form, certificates: updated });
  };

  const handleAdd = () => {
    setForm({
      ...form,
      certificates: [...form.certificates, { title: "", file: null }],
    });
  };

  const handleRemove = (index) => {
    const updated = form.certificates.filter((_, i) => i !== index);
    setForm({ ...form, certificates: updated });
  };

  return (
    <Box className="candidate-section">
      <Box className="candidate-section-head">
        <Typography className="candidate-section-kicker">Section 5</Typography>
        <Typography className="candidate-section-title">Certificates</Typography>
        <Typography className="candidate-section-subtitle">
          Attach credentials and supporting files for screening proof.
        </Typography>
      </Box>

      {form.certificates.length === 0 ? (
        <Box className="candidate-empty-state">
          <Typography>No certificates added yet.</Typography>
        </Box>
      ) : null}

      {form.certificates.map((cert, index) => (
        <Box key={index} className="candidate-entry-card">
          <Box className="candidate-entry-top">
            <Typography className="candidate-entry-title">
              Certificate {index + 1}
            </Typography>
            <IconButton
              type="button"
              onClick={() => handleRemove(index)}
              className="candidate-remove-btn"
            >
              <DeleteIcon />
            </IconButton>
          </Box>

          <TextField
            fullWidth
            label="Certificate Title"
            value={cert.title}
            onChange={(e) => handleChange(index, "title", e.target.value)}
          />

          <Button
            type="button"
            component="label"
            variant="outlined"
            fullWidth
            className="candidate-upload-btn"
          >
            Upload File
            <input
              type="file"
              hidden
              onChange={(e) => handleChange(index, "file", e.target.files[0])}
            />
          </Button>

          {cert.file ? (
            <Typography className="candidate-file-name">
              Selected: {cert.file.name}
            </Typography>
          ) : null}
        </Box>
      ))}

      <Button type="button" variant="outlined" onClick={handleAdd} className="candidate-add-btn">
        Add Certificate
      </Button>
    </Box>
  );
}
